/** Whether Voice Mode and Read Aloud may run for this account on this device; dictation is separate */
import { FEATURES, hasFeature } from '@/features/feature-flags';
import { settingsStore } from '@/stores/settings.store';
import { userStore } from '@/stores/user.store';

export const canUseSpeechFeatures = () =>
  (userStore.isInternalUser || hasFeature(FEATURES.VOICE_MODE)) &&
  settingsStore.speechFeaturesEnabled;
